module.exports = __webpack_public_path__ + "img/licai.a04b8df3.png";